export default {
  index: [
    {
      path: '/ywuser',
      component: resolve => require(['./freshywuserIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/dpywyuser/_router.js